import { __assign, __awaiter, __extends, __generator } from "tslib";
import { AUDIO_EVENTS, STATE_EVENTS, PLAYBACK_EVENTS, } from '@wix/soundhead-playback';
import * as React from 'react';
import { PlaybackContextProvider } from '../../common/PlaybackContext';
import { defaultTrackState, defaultPlayerProps, defaultPlayback, } from '../../defaultSettings';
import { KeyboardKey, } from '../../types';
import { formatTime, debounce } from '../../utils';
var PlayerEngine = /** @class */ (function (_super) {
    __extends(PlayerEngine, _super);
    function PlayerEngine(props) {
        var _this = _super.call(this, props) || this;
        _this.state = defaultTrackState;
        _this.playback = defaultPlayback;
        _this.audioEventSubscriptions = [];
        // @ts-ignore
        _this.saveAudioProps = function (audioProps) {
            _this.setState(__assign({}, audioProps));
        };
        _this._onPlaybackStateChanged = function (_a) {
            var nextState = _a.nextState;
            _this.setState({
                playbackState: nextState,
                isPlaying: [STATE_EVENTS.PLAY_REQUESTED, STATE_EVENTS.PLAYING].some(function (state) { return nextState === state; }),
                isLoading: [
                    STATE_EVENTS.SEEK_IN_PROGRESS,
                    STATE_EVENTS.WAITING,
                    STATE_EVENTS.LOAD_STARTED,
                ].some(function (state) { return nextState === state; }),
            });
        };
        _this._onTrackChanged = function (trackIndex) {
            _this.setState({
                trackIndex: trackIndex,
            });
        };
        _this._onDurationChanged = function (duration) {
            var isLiveStream = !(!!duration && isFinite(duration));
            _this.setState(function (_a) {
                var currentTime = _a.currentTime;
                return ({
                    duration: duration,
                    isLiveStream: isLiveStream,
                    durationFormatted: formatTime(duration),
                    remainingFormatted: formatTime(duration - currentTime),
                });
            });
            _this.props.onDurationChanged(duration);
        };
        _this._onBufferUpdated = function (buffered) {
            _this.setState({ buffered: buffered });
        };
        _this._onTimeUpdated = function (currentTime) {
            _this.setState(function (_a) {
                var duration = _a.duration;
                return ({
                    currentTime: currentTime,
                    currentTimeFormatted: formatTime(currentTime),
                    remainingFormatted: formatTime(duration - currentTime),
                });
            });
            _this.props.onTimeUpdated(currentTime);
        };
        _this._onVolumeChanged = function (volume) {
            _this.setState({ volume: volume });
            _this.props.onVolumeChanged(volume);
        };
        _this._onMuteChanged = function (muted) {
            _this.setState({ muted: muted });
            _this.props.onMuteChanged(muted);
        };
        _this._onRateChange = function (playbackRate) {
            _this.setState({ playbackRate: playbackRate });
            _this.props.onRateChanged(playbackRate);
        };
        _this.play = function () {
            _this.props.onFocus();
            if (_this.state.isPlayingInterrupted) {
                _this.setState({
                    isPlayingInterrupted: false,
                });
            }
            return _this.playback.play();
        };
        /**
         * @param {boolean} interrupted Mark player to return to playing after interruption is over
         */
        _this.pause = function (interrupted) {
            _this.props.onFocus();
            if (interrupted) {
                _this.setState({
                    isPlayingInterrupted: true,
                });
            }
            return _this.playback.pause();
        };
        _this.togglePlay = function () {
            _this.props.onFocus();
            return _this.state.isPlaying ? _this.playback.pause() : _this.playback.play();
        };
        _this.seekTo = function (value) {
            _this.props.onFocus();
            return _this.playback.seekTo(value);
        };
        _this.next = function () {
            _this.props.onFocus();
            _this.playback.next();
            return _this.play();
        };
        _this.previous = function () {
            _this.props.onFocus();
            _this.playback.previous();
            return _this.play();
        };
        _this.changePlaybackRate = function (value) {
            _this.props.onFocus();
            return _this.playback.setPlaybackRate(value);
        };
        _this.changeVolume = function (value) {
            _this.props.onFocus();
            return _this.playback.setVolume(value);
        };
        _this.toggleMute = function () {
            _this.props.onFocus();
            return _this.playback.setMute(!_this.state.muted);
        };
        _this.setTrackIndex = function (index) {
            _this.props.onFocus();
            _this.playback.setTrackIndex(index);
            _this.play();
        };
        _this.getTrackIndex = function () {
            _this.props.onFocus();
            return _this.playback ? _this.playback.getTrackIndex() : 0;
        };
        _this.setFormattedTime = function (value) {
            _this.setState(function (_a) {
                var duration = _a.duration;
                return ({
                    currentTimeFormatted: formatTime(value),
                    remainingFormatted: formatTime(duration - value),
                });
            });
        };
        _this._updateTime = function (value) {
            _this.setState(function (_a) {
                var duration = _a.duration;
                return ({
                    currentTimeFormatted: formatTime(value),
                    remainingFormatted: formatTime(duration - value),
                });
            });
            _this._updateTimeDebounced(value);
        };
        _this._updateTimeDebounced = debounce(function (value) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.seekTo(value)];
                    case 1:
                        _a.sent();
                        this.setState({ isSeeking: false });
                        if (!this.state.isPlayingInterrupted) return [3 /*break*/, 3];
                        this.setState({ isPlayingInterrupted: false });
                        return [4 /*yield*/, this.play()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); }, 200);
        _this.handleKeyDown = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, currentTime, duration, isPlaying, isLiveStream, onePercent, tenPercents, nextTime, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.state, currentTime = _a.currentTime, duration = _a.duration, isPlaying = _a.isPlaying, isLiveStream = _a.isLiveStream;
                        onePercent = duration * 0.01;
                        tenPercents = duration * 0.1;
                        nextTime = currentTime;
                        _b = event.key;
                        switch (_b) {
                            case KeyboardKey.Left: return [3 /*break*/, 1];
                            case KeyboardKey.Up: return [3 /*break*/, 2];
                            case KeyboardKey.Right: return [3 /*break*/, 3];
                            case KeyboardKey.Down: return [3 /*break*/, 4];
                            case KeyboardKey.Space: return [3 /*break*/, 5];
                            case KeyboardKey.Enter: return [3 /*break*/, 7];
                        }
                        return [3 /*break*/, 9];
                    case 1:
                        nextTime -= onePercent;
                        return [3 /*break*/, 10];
                    case 2:
                        nextTime += tenPercents;
                        return [3 /*break*/, 10];
                    case 3:
                        nextTime += onePercent;
                        return [3 /*break*/, 10];
                    case 4:
                        nextTime -= tenPercents;
                        return [3 /*break*/, 10];
                    case 5: return [4 /*yield*/, this.togglePlay()];
                    case 6:
                        _c.sent();
                        return [2 /*return*/];
                    case 7: return [4 /*yield*/, this.togglePlay()];
                    case 8:
                        _c.sent();
                        return [2 /*return*/];
                    case 9: return [2 /*return*/];
                    case 10:
                        if (isLiveStream) {
                            return [2 /*return*/];
                        }
                        if (nextTime > duration) {
                            nextTime = duration;
                        }
                        else if (nextTime < 0) {
                            nextTime = 0;
                        }
                        if (!isPlaying) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.pause(true)];
                    case 11:
                        _c.sent();
                        _c.label = 12;
                    case 12:
                        this.setState({ currentTime: nextTime, isSeeking: true });
                        this._updateTime(nextTime);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.composePlaybackContext = function () {
            var playlist = _this.props.playlist;
            var track = playlist[_this.state.trackIndex];
            return __assign(__assign({ play: _this.play, pause: _this.pause, next: _this.next, previous: _this.previous, togglePlay: _this.togglePlay, seekTo: _this.seekTo, setPlaybackRate: _this.changePlaybackRate, toggleMute: _this.toggleMute, setVolume: _this.changeVolume, handleKeyDown: _this.props.onKeyDown || _this.handleKeyDown, setTrackIndex: _this.setTrackIndex, getTrackIndex: _this.getTrackIndex, setFormattedTime: _this.setFormattedTime, playlist: playlist }, _this.state), track);
        };
        _this.state = __assign(__assign({}, _this.state), { duration: props.duration, durationFormatted: formatTime(props.duration), remainingFormatted: formatTime(props.duration), volume: props.volume, playbackRate: props.playbackRate, muted: props.muted, loop: props.loop, autoplay: props.autoplay, preload: props.preload });
        return _this;
    }
    PlayerEngine.prototype.componentWillUnmount = function () {
        this.unbindAudioEvents();
    };
    PlayerEngine.prototype.injectPlayback = function (playback) {
        this.playback = playback;
    };
    PlayerEngine.prototype.registerPlayer = function () {
        this.playback.registerPlayer(this.props.playerId);
        this.playback.setPlaylist(this.props.playlist);
        this.updateTrack();
    };
    PlayerEngine.prototype.updateTrack = function () {
        var _this = this;
        var _a = this.state, volume = _a.volume, muted = _a.muted, playbackRate = _a.playbackRate, loop = _a.loop, preload = _a.preload, trackIndex = _a.trackIndex, currentTime = _a.currentTime, autoplay = _a.autoplay;
        var audioProps = {
            volume: volume,
            muted: muted,
            playbackRate: playbackRate,
            loop: loop,
            preload: preload,
            autoplay: autoplay,
        };
        this.playback.setAudioProps(audioProps);
        this.playback.setTrackIndex(trackIndex);
        if (currentTime !== 0) {
            var onCanPlay_1 = function () {
                _this.playback.seekTo(currentTime);
            };
            this.playback.once(AUDIO_EVENTS.CAN_PLAY_TROUGH, onCanPlay_1);
            this.audioEventSubscriptions.push(function () {
                return _this.playback.off(AUDIO_EVENTS.CAN_PLAY_TROUGH, onCanPlay_1);
            });
        }
    };
    PlayerEngine.prototype.bindAudioEvents = function () {
        var _this = this;
        this.audioEventSubscriptions = [];
        var eventsMap = [
            [PLAYBACK_EVENTS.STATE_CHANGED, this._onPlaybackStateChanged],
            [PLAYBACK_EVENTS.TRACK_CHANGED, this._onTrackChanged],
            [AUDIO_EVENTS.DURATION_CHANGED, this._onDurationChanged],
            [AUDIO_EVENTS.TIME_UPDATED, this._onTimeUpdated],
            [AUDIO_EVENTS.BUFFER_UPDATED, this._onBufferUpdated],
            [AUDIO_EVENTS.VOLUME_CHANGED, this._onVolumeChanged],
            [AUDIO_EVENTS.MUTE_CHANGED, this._onMuteChanged],
            [AUDIO_EVENTS.RATE_CHANGED, this._onRateChange],
            [AUDIO_EVENTS.ABORT, this.props.onAborted],
            [AUDIO_EVENTS.ERROR, this.props.onError],
            [STATE_EVENTS.READY_TO_PLAY, this.props.onTrackReadyToPlay],
            [STATE_EVENTS.PLAY_REQUESTED, this.props.onPlayRequested],
            [STATE_EVENTS.PLAYING, this.props.onPlay],
            [STATE_EVENTS.PAUSED, this.props.onPause],
            [STATE_EVENTS.ENDED, this.props.onEnded],
        ];
        var playbackContext = this.composePlaybackContext();
        eventsMap.forEach(function (_a) {
            var event = _a[0], fn = _a[1];
            _this.playback.on(event, fn, playbackContext);
            _this.audioEventSubscriptions.push(function () {
                return _this.playback.off(event, fn, playbackContext);
            });
        });
    };
    PlayerEngine.prototype.unbindAudioEvents = function () {
        this.audioEventSubscriptions.forEach(function (unbind) {
            unbind();
        });
        this.audioEventSubscriptions = [];
    };
    PlayerEngine.prototype.resetPlaybackState = function () {
        this.setState({
            playbackState: STATE_EVENTS.INIT,
            isPlaying: false,
            isLoading: false,
        });
    };
    PlayerEngine.prototype.render = function () {
        return (React.createElement(PlaybackContextProvider, { value: this.composePlaybackContext() }, this.props.children));
    };
    PlayerEngine.displayName = 'PlayerEngine';
    PlayerEngine.defaultProps = defaultPlayerProps;
    return PlayerEngine;
}(React.Component));
export default PlayerEngine;
//# sourceMappingURL=PlayerEngine.js.map